module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locale/resources/xx-xx.json
// module id = 3DjT
// module chunks = 1